var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9994 41.8346C9.4931 41.8346 0.166016 32.5076 0.166016 21.0013C0.166016 9.49505 9.4931 0.167969 20.9994 0.167969C32.5056 0.167969 41.8327 9.49505 41.8327 21.0013C41.8327 32.5076 32.5056 41.8346 20.9994 41.8346ZM18.916 22.6513V29.3346H23.0827V22.6513C24.1794 22.1727 25.0778 21.331 25.6269 20.2679C26.176 19.2048 26.3423 17.985 26.0978 16.8137C25.8534 15.6424 25.213 14.5909 24.2845 13.8362C23.356 13.0815 22.1959 12.6695 20.9994 12.6695C19.8028 12.6695 18.6427 13.0815 17.7142 13.8362C16.7857 14.5909 16.1453 15.6424 15.9009 16.8137C15.6564 17.985 15.8227 19.2048 16.3718 20.2679C16.9209 21.331 17.8193 22.1727 18.916 22.6513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyWhite);
export default __webpack_public_path__ + "static/media/keyWhite.5548f78a87cad3c0f04c2d88056092e2.svg";
export { ForwardRef as ReactComponent };